/* eslint-disable max-len */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

require('./src/styles/fonts.css')

function intersectionObserverSupported () {
  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get () {
          return this.intersectionRatio > 0
        },
      })
    }
    return true
  }

  return false
}

function smoothScrollSupported () {
  return 'scrollBehavior' in document.documentElement.style
}

function fetchSupported () {
  return typeof window !== 'undefined' && 'fetch' in window
}

function promiseSupported () {
  return typeof window !== 'undefined' && typeof Promise !== 'undefined'
}

function loadScript (src) {
  const js = document.createElement('script')
  js.src = src
  document.head.appendChild(js)
}

exports.shouldUpdateScroll = () => false

exports.onClientEntry = () => {
  const polyfills = []

  if (!intersectionObserverSupported()) {
    polyfills.push('IntersectionObserver')
  }

  if (!smoothScrollSupported()) {
    polyfills.push('smoothscroll')
  }

  if (!fetchSupported()) {
    polyfills.push('fetch')
  }

  if (!promiseSupported()) {
    polyfills.push('Promise')
  }

  if (polyfills.length > 0) {
    loadScript(`https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=${ polyfills.join('%2C') }`)
  }
}
